
export default function WelcomeHeader() {
  return (
    <div className="bg-gradient-to-br from-[#007AFF] to-[#00B4DB] rounded-3xl p-6 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>
      
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-2xl font-bold mb-1">مرحباً بك في تكافل بلس</h2>
            <p className="text-white/90 text-sm">إدارة ذكية لخدماتك الطبية</p>
          </div>
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
            <i className="ri-heart-pulse-fill text-2xl"></i>
          </div>
        </div>
        
        <div className="flex items-center gap-2 text-sm">
          <i className="ri-map-pin-line"></i>
          <span>الرياض، المملكة العربية السعودية</span>
        </div>
      </div>
    </div>
  );
}
